export default __webpack_public_path__ + "static/media/search-empty-result.948cd684.svg";